<template lang="pug">
    v-layout.align-center(raw wrap)


        v-flex.mt-3(xs12)

            // Select program
            v-select(
                name="createdAt"
                append-icon="expand_more"
                outline
                v-model="model.definitions.program.id"
                item-text="title"
                item-value="id"
                @change="setProgram"
                :items="programs"
                label="Program Templates"
            )

        v-flex(xs6)
          title-component(title="Practices" type="h5")
        v-flex(xs6)
          div.c-form.mr-2
            // Search field
            v-text-field(
              :label="$t('fields.search')"
              v-model="search"
              append-icon="search"
              class="search-input"
              outline
            )
        v-flex(xs12)

            v-data-table.c-table(
                v-model="selected"
                :headers="headers"
                :items="sessions"
                :pagination.sync="pagination"
                item-key="name"
                class="elevation-1"
                :rowsPerPageItems="[12]"
                :search="search"
                )
                  template(v-slot:headers="props")
                    tr
                      th(
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                        @click="changeSort(header.value)"
                      ) {{ header.text }}
                        v-icon arrow_upward

                  template(v-slot:items="props")
                    practice-item(:practice="props.item")
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import practiceItem from './practiceItem';
    import Title from '~components/Title';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            practiceItem,
            TitleComponent: Title
        },
        data() {
            return {
                search: '',
                sessionUpdated: false,
                pagination: {
                    sortBy: 'session_title'
                },
                selected: [],
                headers: [
                    {
                        text: 'Practice Name',
                        align: 'left',
                        value: 'session_title'
                    },
                    { text: 'Instructor', value: 'instructor_fullName' },
                    { text: 'Duration', value: 'session_duration' },
                    { text: '', value: '' }
                ]
            };
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            }),
            ...mapGetters('programs', ['isLoading', 'programs']),
            ...mapGetters('sessions', ['sessions']),
            ...mapGetters('businesses', ['isChallenge'])
        },
        watch: {
            ['model.definitions.sessions'](val, oldVal) {
                if (
                    oldVal &&
                    val &&
                    oldVal.length < val.length &&
                    this.sessionUpdated
                ) {
                    let lastElement = this.model.definitions.sessions.pop();
                    this.model.definitions.sessions.unshift(lastElement);
                }
                this.sessionUpdated = false;
            }
        },
        beforeMount() {
            this.getAllSessionsWithInstrutor();
            this.getFlatPrograms();
        },
        methods: {
            ...mapActions('sessions', ['getAllSessionsWithInstrutor']),
            ...mapActions('programs', ['getFlatPrograms', 'read']),
            ...mapActions('businesses', ['setBusinessProgram']),

            updateSessions() {
                this.sessionUpdated = true;
            },
            /**
             * Set business program from template
             * @returns {Promise<void>}
             */
            async setProgram() {
                if (this.model.definitions.program.id) {
                    await this.read(this.model.definitions.program.id);
                    this.setBusinessProgram();
                }
            },

            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending;
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false;
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    >>> .v-select__selections
        overflow-x: auto
</style>
